// Libs
// import jQuery from 'jquery'
// import Swal from 'sweetalert2';
// import flatpickr from 'flatpickr';
// import jQuery from 'jquery';

// import ModuleTab from "./Public/ModuleTab";
import ModuleCalcElement from "./Public/ModuleCalcElement";
import ModuleFancybox from "./Public/ModuleFancybox";
import AnchorScroll from "./Public/AnchorScroll";
import SVGImport from "./Public/SVGImport";
import Wysiwyg from "./Public/Wysiwyg";
import ModuleSwiper from "./Public/ModuleSwiper";
// import CountNumbers from "./Public/CountNumbers";
import Observerjs from "./Classes/Observerjs";
import FAQ from "./Public/FAQ";

// import ModuleTab from "./Public/ModuleTab";
// import ModuleSelect2 from "./Public/ModuleSelect2";
// import Upload from "./Public/Upload";
// import TableOfContents from "./Public/TableOfContents";
// import ModuleCopyToClipboard from "./Public/ModuleCopyToClipboard";
import Header from "./Layouts/Header";
import ModuleTranslates from "./Public/ModuleTranslates";
import BackToTop from "./Public/BackToTop";
// import ModuleEffects from "./Public/ModuleEffects";
// import CallAPI from "./Public/CallAPI";
// import Accordion from "./Public/Accordion";
// import ModuleMaps from "./Public/ModuleMaps";

const BraneyModulesManager = {
    runModule: function () {
        //intBox
        // new Accordion();
        // new ModuleTab(document.querySelector('.js-tab-statement'));
        // new ModuleTab(document.querySelector('.js-tab-post'));
        // new ModuleMaps();

        new ModuleCalcElement();
        new ModuleFancybox();
        new AnchorScroll();
        new SVGImport().init();
        new Wysiwyg();
        new ModuleSwiper();
        new FAQ();
        new BackToTop().init();
        // new ModuleSelect2();
        // new Upload();
        // new TableOfContents();
        // new ModuleCopyToClipboard().init();
        // new ModuleTab(document.querySelector('.js-tab-khang'));
        // document.querySelectorAll('.js-machine-tabs')?.forEach((item)=> {
        //     new ModuleTab(item);
        // })
        
        new Header();
        new ModuleTranslates();
        // new ModuleEffects();
        // new CountNumbers().init();
        new Observerjs().init();
        // new ModuleTranslates();
        // new CallAPI().init();

            

        // Add MutationObserver
        // const observer = new MutationObserver(function (mutationsList, observer) {
        //     for (const mutation of mutationsList) {
        //         if (mutation.addedNodes.length) {
        //             mutation.addedNodes.forEach(node => {
        //                 if (node.nodeType === Node.ELEMENT_NODE) {
        //                     node.querySelectorAll('.__select2__').forEach(function (item) {
        //                         new TrackTrace();
        //                     })
        //                 }
        //             });
        //         }
        //     }
        // });
        // observer.observe(document.body, { childList: true, subtree: true });

        // Swal.fire({ showClass: "", 
        //     title: "Thank you!", 
        //     text: "That thing is still around?",
        //     icon: "success", 
        //     showCloseButton: true, confirmButtonText: 'Download Our PDF Catalog',
        // }).then((result) => { 
        //     if (result.isConfirmed) {
        //         // thay link bằng link PDF hoặc link bạn muốn mở
        //         window.location.href = "https://example.com/catalog.pdf";
        //     }
        // });
    }
};

document.addEventListener('DOMContentLoaded', function () {
    BraneyModulesManager.runModule();
    document.body.style.opacity = "";
})